import GameList from '../components/game/List'
import GameCreate from '../components/game/Create'
import GameUpdate from '../components/game/Update'

export default [
  { name: 'GameList', path: '/games/', component: GameList, props: { pageTitle: 'Game List' } },
  { name: 'GameCreate', path: '/games/create', component: GameCreate, props: { pageTitle: 'Game Create' } },
  { name: 'GameUpdate', path: '/games/edit/:id', component: GameUpdate, props: { pageTitle: 'Game Update' } }
]
